import React from "react";
import styles from "./style.module.scss";
import TvEnergyDataManager from "../../../components/DataManagers/TVEnergyDataManager";
import EnergyTable from "../../../components/TVEnergy/EnergyTable";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";

function TVEnergyTablePage() {
  return (
    <div className={styles.fullscreen}>
      <div className={styles.energyGraphContainer}>
        <TvEnergyDataManager />
        <TimingDataManager />
        <EnergyTable />
      </div>
    </div>
  );
}

export default TVEnergyTablePage;
